import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, FormGroup, FormControl, ControlLabel, Row, Col, Clearfix} from 'react-bootstrap';
import styled from 'styled-components';
import {FilterSelectStyled} from '../../../../../components/filters/FiltersStyled';
import Select from 'react-select';
import {PathFieldStyled, CheckboxStyled} from '../ModalStyled';
import Table from './table/Table';
import {buildWOInfo, getValueForOS, preparePathForOsWithoutRoot} from '../../../utils';
import _ from 'lodash';
import Paginate from '../../table/Paginate';
import {confirmAlert} from 'react-confirm-alert'
import FolderExplorerNew from '../../forms/FolderExplorerNew';
import {
  changeOpenedFoldersInModal,
  setFoldersInModal,
  showAvailableManualMemfisWOsModal,
  searchAvailableManualMemfisWOs,
  linkToMemfisWO,
  getClientListByWoMemfisId,
  setClientNameForWoMemfisId,
  getAssetFinalDestination,
  createArtworkWorkOrderByFName,
  setNewWOByFName,
  setUseFinalDestinationDataReserved, activateWoStep, clearWoStepsData, markAsperaLinkAsCompleted,
  cancelArtworkAssets, searchArtworkWorkOrder, validateArtworkFolder
} from '../../../actions';
import TextEllipsisAdvanced from '../../../../../components/TextEllipsis/TextEllipsisAdvanced';
import Spinner from 'react-spinner';
import Wizard from '../../../../../components/Wizard/Wizard';
import InBurbankStep, {CONTINUE_COMPLETE_DOWNLOAD, CONTINUE_SINGLE_LINK_WO} from './InBurbankStep';
import Checkbox from "react-bootstrap/lib/Checkbox";
import Radio from "react-bootstrap/lib/Radio";
import WarningIcon from "../../../../../components/icons/WarningIcon";
import {formatDate} from '../../../../../utils';
import moment from 'moment';

const Steps = {
  IN_BURBANK: 'In Burbank',
  SELECT_WO: 'Select WO#',
  CONFIRM: 'Confirm',
  WO_STEPS: 'WO Steps to mark as complete',
  ARTWORK_WO_SETUP: 'Artwork WO Setup',
  ARTWORK_WO: 'Artwork Work Order'
};

const CLIENTS_OPTION_ALL = {value: 'All', label: 'All'};
const ARTWORK_WO_TYPE = {
  GENERAL: 'general',
  CUSTOM: 'custom'
};

const ASPERA_LINK_STATUS = {
  0: 'NEW',
  1: 'COMPLETED',
  2: 'DOWNLOADED',
  3: 'FAILED',
  4: 'EXPIRED',
  5: 'ENCRYPTED',
  6: 'DECRYPTING',
  7: 'PARTIALLY_COMPLETED'
};

class LinkToMemfisWoModal extends Component {

  getAsperaLinkStatusText = (statusValue) => {
    return ASPERA_LINK_STATUS[statusValue] || `UNKNOWN(${statusValue})`;
  };

  getDefaultStateForSelectWo = (props) => {
    let result = /WO[0-9]{7}/gm.exec(props.item.key);
    if (!result) {
      result = /WO[0-9]{7}/gm.exec(props.item.fullPath);
    }
    return {
      currentPage: 0,
      filterText: result ? result[0] : '',
      filterClient: CLIENTS_OPTION_ALL.value,
      clients: [CLIENTS_OPTION_ALL],
      selectedWorkOrder: null,
    };
  };

  state = {
    ...this.getDefaultStateForSelectWo(this.props),
    isBeginIngest: true,
    sendCaptionsToQod: true,
    fsRootId: this.props.item.fsRootID,
    fileType: null,
    projectType: null,
    isDefaultFileType: true,
    selectedFolder: null,
    confirmedDestination: false,
    isSelectingDestination: false,
    inputValue: '',
    resultValue: '',
    inBurbankStepData: {
      singleLinking: false,
      searchWOsForContent: false,
      continueVariant: null
    },
    isAllWoSteps: false,
    artworkWoCustomType: false,
    artworkDuplicateAssetList: [],
    artworkWoid: null,
    selectedAssetsForCancel: {},
    artworkValidationResults: null,
    artworkValidationLoading: false,
    expandedZipFiles: {},
    checkedZipLkfs: {},
    checkedZipProxy: {}
  };

  scheduleServerSearch = _.debounce((filterText, filterClient, page) => {
    this.runServerSearch(filterText, filterClient, page, false);
  }, 400);

  runServerSearch = (filterText, filterClient, page, includeClients) => {
    const {dispatch, storageManager} = this.props;
    if (!dispatch || !storageManager.linkToWoQuery) {
      return;
    }
    if (!includeClients && !storageManager.linkToWoServerSearch) {
      return;
    }
    this.lastServerSearchText = filterText || '';
    this.lastServerSearchClient = filterClient;
    dispatch(searchAvailableManualMemfisWOs(storageManager.linkToWoQuery, filterText, filterClient, page, includeClients));
  };

  initFoldersInExplorer = () => {
    const {dispatch, storageManager: {fsRoots}, workOrders} = this.props;
    if (!workOrders || !dispatch) {
      return;
    }
    const {linkToWoServerSearch, linkToWoClients} = this.props.storageManager;
    if (!linkToWoServerSearch && !linkToWoClients && this.state.clients.length <= 1) {
      const options =
        _.sortBy(
          _.uniqBy(
            workOrders.filter(i => i.clientName).map(i => ({value: i.clientName, label: i.clientName})),
          'value'),
        ['value']);
      this.setState({clients: [CLIENTS_OPTION_ALL, ...options]});
    }
    let folders = fsRoots.map(i => ({...i}));
    dispatch(changeOpenedFoldersInModal({}));
    dispatch(setFoldersInModal(folders));
  };

  componentDidMount() {
    this.initFoldersInExplorer();
    const {linkToWoQuery} = this.props.storageManager;
    if (linkToWoQuery) {
      this.runServerSearch(this.state.filterText, this.state.filterClient, 0, true);
    }
  }

  componentWillUnmount() {
    this.scheduleServerSearch.cancel();
    const {dispatch} = this.props;
    dispatch && dispatch(setNewWOByFName(null));
    if (this.wizard) {
      this.wizard.setActiveStepKey(Steps.SELECT_WO);
    }
  }

  componentDidUpdate(prevProps) {
    const {projectType} = this.state;
    const {finalDestinationData, useFinalDestinationDataReserved, dispatch, workOrders, item, storageManager: {newWoByFName, linkToWoQuery, linkToWoClients}} = this.props;
    if (linkToWoQuery && linkToWoQuery !== prevProps.storageManager.linkToWoQuery) {
      this.runServerSearch(this.state.filterText, this.state.filterClient, 0, true);
    }
    const serverSearchJustEnabled = this.props.storageManager.linkToWoServerSearch && !prevProps.storageManager.linkToWoServerSearch;
    if (serverSearchJustEnabled) {
      const typed = (this.state.filterText || '').trim();
      const searched = (this.lastServerSearchText || '').trim();
      const clientChanged = this.state.filterClient !== (this.lastServerSearchClient || CLIENTS_OPTION_ALL.value);
      if (typed !== searched || clientChanged) {
        this.runServerSearch(this.state.filterText, this.state.filterClient, this.state.currentPage, false);
      }
    }
    if (linkToWoClients && linkToWoClients !== prevProps.storageManager.linkToWoClients) {
      this.setState({
        clients: [CLIENTS_OPTION_ALL, ...linkToWoClients.filter(Boolean).map(name => ({value: name, label: name}))]
      });
    }
    if(projectType === null && finalDestinationData && finalDestinationData.default_project_type) {
      this.setState({
        ...this.state,
        projectType: finalDestinationData.default_project_type
      })
    }
    if (JSON.stringify(workOrders) !== JSON.stringify(prevProps.workOrders) || (dispatch && !prevProps.dispatch)) {
      this.initFoldersInExplorer();
    }

    if (this.wizard.getActiveStepKey() !== Steps.CONFIRM && newWoByFName) {
      this.setState({
        fsRootId: item.fsRootID
      });
      this.onSelectMemfisWoIdOrVolume(newWoByFName, null, () => {
        const {finalDestinationData} = this.props;
        let root_id = item.fsRootID;
        if (finalDestinationData && finalDestinationData.root_id) {
          root_id = finalDestinationData.root_id;
        }
        this.setState({fsRootId: root_id});
        this.setFoldersInModal(root_id);
      });
      this.wizard.setActiveStepKey(Steps.CONFIRM);
    }

    const {fsRootId} = this.state;
    if (useFinalDestinationDataReserved && finalDestinationData && fsRootId !== finalDestinationData.root_id) {
      this.setState({fsRootId: finalDestinationData.root_id});
      this.setFoldersInModal(finalDestinationData.root_id);
      dispatch && dispatch(setUseFinalDestinationDataReserved());
    }
  }

  handlePageClick = page => {
    const nextPage = page.selected;
    this.setState({currentPage: nextPage});
    if (this.props.storageManager.linkToWoServerSearch) {
      this.scheduleServerSearch.cancel();
      this.runServerSearch(this.state.filterText, this.state.filterClient, nextPage, false);
    }
  };

  getDefaultFsRootID = selectedWorkOrder => {
    const {finalDestinationData, item, storageManager: {newWoByFName}} = this.props;
    if ((!selectedWorkOrder && !newWoByFName) ||
        !finalDestinationData || (selectedWorkOrder && finalDestinationData.woMemfisId !== selectedWorkOrder.woMemfisId)) {
      return item.fsRootID;
    }
    return finalDestinationData.root_id;
  }

  getCurrentFinalDestinationPath = () => {
    const {finalDestinationData, storageManager: {newWoByFName}} = this.props;
    const {selectedWorkOrder, fsRootId} = this.state;
    if ((!selectedWorkOrder && !newWoByFName) || !fsRootId ||
        !finalDestinationData || (!newWoByFName && finalDestinationData.woMemfisId !== selectedWorkOrder.woMemfisId)) {
      return null;
    }
    return finalDestinationData.final_destination;
  };

  getCurrentFinalDestinationRootId = () => {
    const {finalDestinationData, storageManager: {newWoByFName}} = this.props;
    const {selectedWorkOrder, fsRootId} = this.state;
    if ((!selectedWorkOrder && !newWoByFName) || !fsRootId ||
        !finalDestinationData || finalDestinationData.woMemfisId !== selectedWorkOrder.woMemfisId) {
      return null;
    }
    return finalDestinationData.root_id;
  };

  getCurrentFinalDestinationKey = () => {
    const {finalDestinationData, storageManager: {newWoByFName}} = this.props;
    const {selectedWorkOrder, fsRootId} = this.state;
    if ((!selectedWorkOrder && !newWoByFName) || !fsRootId ||
        !finalDestinationData || (selectedWorkOrder && finalDestinationData.woMemfisId !== selectedWorkOrder.woMemfisId)) {
      return null;
    }
    return finalDestinationData.default_final_destination;
  };

  isWorkOrderWithoutClient = workOrder => {
    return !!workOrder && !workOrder.clientName;
  };

  handleClose = () => {
    const {dispatch} = this.props;
    dispatch && dispatch(showAvailableManualMemfisWOsModal(false));
    dispatch && dispatch(setNewWOByFName(null));
  };

  handleNewArtworkWorkOrder = () => {
    const {item, dispatch} = this.props;
    const {fsRootID, contentID} = item;
    dispatch(searchArtworkWorkOrder(fsRootID, contentID)).then(() => {
      const {storageManager: {newWoByFName}} = this.props;
      if (!newWoByFName) {
        this.wizard.setActiveStepKey(Steps.ARTWORK_WO_SETUP);
      }
    });
  }

  handleValidateArtworkFolder = () => {
    const {item, dispatch} = this.props;
    const {fsRootID, contentID} = item;
    const artworkWoCustomSeries = this.customSeriesInput ? this.customSeriesInput.value : this.state.artworkWoCustomSeries;
    const artworkCustomConceptName = this.conceptNameInput ? this.conceptNameInput.value : this.state.artworkCustomConceptName;
    this.setState({artworkValidationLoading: true, artworkValidationResults: null, artworkWoCustomSeries, artworkCustomConceptName});
    dispatch(validateArtworkFolder(fsRootID, contentID, artworkWoCustomSeries, artworkCustomConceptName)).then(
      (validationResults) => {
        const initialLkfs = {};
        const initialProxy = {};
        if (validationResults && validationResults.zip_files) {
          validationResults.zip_files.forEach(zipFile => {
            if (zipFile.zip_content) {
              zipFile.zip_content.forEach(contentItem => {
                const key = `${zipFile.content_id}::${contentItem.file}`;
                if (contentItem.is_audiostem_lkfs) {
                  initialLkfs[key] = true;
                }
                if (contentItem.is_audiostem_proxy) {
                  initialProxy[key] = true;
                }
              });
            }
          });
        }
        this.setState({
          artworkValidationResults: validationResults,
          artworkValidationLoading: false,
          checkedZipLkfs: initialLkfs,
          checkedZipProxy: initialProxy
        });
        this.wizard.setActiveStepKey(Steps.ARTWORK_WO);
      }
    ).catch(() => {
      this.setState({artworkValidationLoading: false});
    });
  }

  handleChangeArtworkWoType = (event) => {
    this.setState({artworkWoCustomType: ARTWORK_WO_TYPE.CUSTOM === event.target.value});
  }

  handleCreateArtworkWorkOrder = () => {
    const {item, dispatch} = this.props;
    const {artworkWoCustomType, artworkWoid, checkedZipLkfs, checkedZipProxy} = this.state;

    if (artworkWoid) {
      const {selectedAssetsForCancel} = this.state;
      const assetIds = Object.keys(selectedAssetsForCancel).filter(id => selectedAssetsForCancel[id]).map(id => parseInt(id));

      dispatch(cancelArtworkAssets(assetIds, artworkWoid));
      return;
    }

    const {fsRootID, contentID} = item;
    const artworkWoCustomSeries = artworkWoCustomType ? this.state.artworkWoCustomSeries : undefined;
    const artworkCustomConceptName = artworkWoCustomType ? this.state.artworkCustomConceptName : undefined;

    const {artworkValidationResults} = this.state;
    const initLkfs = {};
    const initProxy = {};
    if (artworkValidationResults && artworkValidationResults.zip_files) {
      artworkValidationResults.zip_files.forEach(zipFile => {
        if (zipFile.zip_content) {
          zipFile.zip_content.forEach(contentItem => {
            const key = `${zipFile.content_id}::${contentItem.file}`;
            if (contentItem.is_audiostem_lkfs) initLkfs[key] = true;
            if (contentItem.is_audiostem_proxy) initProxy[key] = true;
          });
        }
      });
    }
    const filterTrue = obj => {
      const result = {};
      for (const k in obj) { if (obj[k]) result[k] = true; }
      return result;
    };
    const objsEqual = (a, b) => {
      const keysA = Object.keys(a);
      const keysB = Object.keys(b);
      if (keysA.length !== keysB.length) return false;
      return keysA.every(k => k in b);
    };
    const lkfsChanged = !objsEqual(filterTrue(checkedZipLkfs), initLkfs);
    const proxyChanged = !objsEqual(filterTrue(checkedZipProxy), initProxy);

    dispatch && dispatch(createArtworkWorkOrderByFName(fsRootID, contentID, artworkWoCustomSeries, artworkCustomConceptName, lkfsChanged ? checkedZipLkfs : {}, proxyChanged ? checkedZipProxy : {})).then(
      (response) => {
        if (response.woid && response.duplicate_asset_list) {
          this.setState({
            artworkWoid: response.woid,
            artworkDuplicateAssetList: response.duplicate_asset_list
          });
        }
      }
    );
  }

  handleToggleArtworkAssetForCancel = (requestID) => {
    this.setState(prevState => ({
      selectedAssetsForCancel: {
        ...prevState.selectedAssetsForCancel,
        [requestID]: !prevState.selectedAssetsForCancel[requestID]
      }
    }));
  }

  handleToggleAllArtworkAssetsForCancel = () => {
    const {artworkDuplicateAssetList, selectedAssetsForCancel} = this.state;
    const allSelected = artworkDuplicateAssetList.every(asset => !!selectedAssetsForCancel[asset.RequestID]);
    const updated = {};
    artworkDuplicateAssetList.forEach(asset => {
      updated[asset.RequestID] = !allSelected;
    });
    this.setState({selectedAssetsForCancel: updated});
  }

  handleToggleZipFileExpanded = (fileName) => {
    this.setState(prevState => ({
      expandedZipFiles: {
        ...prevState.expandedZipFiles,
        [fileName]: !prevState.expandedZipFiles[fileName]
      }
    }));
  }

  handleToggleZipLkfsItem = (contentId, contentFile) => {
    const key = `${contentId}::${contentFile}`;
    this.setState(prevState => ({
      checkedZipLkfs: {
        ...prevState.checkedZipLkfs,
        [key]: !prevState.checkedZipLkfs[key]
      }
    }));
  }

  handleSelectZipProxyItem = (contentId, contentFile) => {
    const key = `${contentId}::${contentFile}`;
    this.setState(prevState => {
      const isAlreadySelected = !!prevState.checkedZipProxy[key];
      // Remove any existing proxy selection for this zip (same contentId)
      const updated = {};
      for (const k in prevState.checkedZipProxy) {
        if (!k.startsWith(`${contentId}::`)) {
          updated[k] = prevState.checkedZipProxy[k];
        }
      }
      if (!isAlreadySelected) {
        updated[key] = true;
      }
      return {checkedZipProxy: updated};
    });
  }

  handleLinkToWO = () => {
    const {dispatch, requestedPage, linkToMemfisWOCallback, storageManager: {newWoByFName}, woSteps} = this.props;
    const {selectedWorkOrder, isBeginIngest, sendCaptionsToQod, fsRootId, confirmedDestination, resultValue} = this.state;
    let steps = null;
    if (woSteps) {
      steps = woSteps
        .filter((step) => step.activate)
        .map(({step_id}) => step_id);
    }

    const submit = () => {
      const destinationPath = confirmedDestination ? resultValue : this.getCurrentFinalDestinationKey();
      const params = {
        requestedPage,
        memfisWO: newWoByFName ? {woMemfisId: newWoByFName} : selectedWorkOrder,
        fsRootID2: fsRootId,
        destinationPath,
        isBeginIngest,
        sendCaptionsToQod,
        successCallback: linkToMemfisWOCallback,
        steps
      };
      this.setState({isAllWoSteps: false});
      dispatch && dispatch(linkToMemfisWO(params));
    };
    if (this.isWorkOrderWithoutClient(selectedWorkOrder)) {
      confirmAlert({
        title: 'Are You Sure?',
        message: 'Are you sure you want to link to work order without client info?',
        buttons: [{
          label: 'No'
        }, {
          label: 'Yes',
          onClick: submit
        }]
      });
    } else {
      submit();
    }
  };

  handleLoadClientList = woMemfisId => {
    const {dispatch} = this.props;
    dispatch && dispatch(getClientListByWoMemfisId(woMemfisId));
  };

  handleSelectClientName = (woMemfisId, clientName) => {
    const {dispatch} = this.props;
    dispatch && dispatch(setClientNameForWoMemfisId(woMemfisId, clientName)).then(
      () => {
        const {clients} = this.state;
        if (!clients.find(i => i.value === clientName)) {
          this.setState({clients: [...clients, {value: clientName, label: clientName}]});
        }
      }
    );
  };

  setFoldersInModal = (rootId) => {
    const {dispatch, storageManager: {fsRoots}} = this.props;
    const folders = fsRoots.filter(i => i.fsRootID === rootId).map(i => ({...i}));
    if (folders && dispatch) {
      dispatch(setFoldersInModal(folders));
    }
  }

  onSelectMemfisWoIdOrVolume = (woMemfisId, preferredRootId, callback, projectType) => {
    const {dispatch} = this.props;
    dispatch && dispatch(getAssetFinalDestination(woMemfisId, preferredRootId, projectType)).then(
      () => {
        callback && callback();
      }
    );
  };

  handleSelectWO = selectedWorkOrder => {
    this.setState({
      selectedWorkOrder,
      fsRootId: this.getDefaultFsRootID(selectedWorkOrder)
    });
    this.onSelectMemfisWoIdOrVolume(selectedWorkOrder.woMemfisId, null, () => {
      this.setState({fsRootId: this.getDefaultFsRootID(selectedWorkOrder)});
      this.setFoldersInModal(this.getDefaultFsRootID(selectedWorkOrder));
    });
    this.wizard.setActiveStepKey(Steps.WO_STEPS);
  };

  handleSelectFsRoot = selectedRootId => {
    const {selectedWorkOrder, fsRootId} = this.state;
    const { storageManager: {newWoByFName}} = this.props;
    const woMemfisId = newWoByFName ? newWoByFName : selectedWorkOrder.woMemfisId
    if (fsRootId !== selectedRootId) {
      this.setState({
        fsRootId: selectedRootId
      });
      this.onSelectMemfisWoIdOrVolume(woMemfisId, selectedRootId);
      this.setFoldersInModal(selectedRootId);
    }
  };

  handleSelectFileType = type => {
    const {finalDestinationData} = this.props;
    const {selectedWorkOrder, fsRootId} = this.state;
    const { storageManager: {newWoByFName}} = this.props;
    const woMemfisId = newWoByFName ? newWoByFName : selectedWorkOrder.woMemfisId
    this.setState({
      ...this.state,
      fileType: type,
      projectType: finalDestinationData.default_project_type,
      isDefaultFileType: true
    })
    this.onSelectMemfisWoIdOrVolume(woMemfisId, fsRootId, null, finalDestinationData.default_project_type);
  };

  handleSelectProjectType = type => {
    const {finalDestinationData, storageManager: {newWoByFName}} = this.props;
    const {selectedWorkOrder, fsRootId} = this.state;
    const woMemfisId = newWoByFName ? newWoByFName : selectedWorkOrder.woMemfisId
    this.setState({
      ...this.state,
      projectType: type,
      isDefaultFileType: type === finalDestinationData.default_project_type
    })
    this.onSelectMemfisWoIdOrVolume(woMemfisId, fsRootId, null, type);
  };

  handleSearchFilter = event => {
    const filterText = event.target.value;
    this.setState({
      currentPage: 0,
      filterText,
      selectedWorkOrder: null,
      fsRootId: this.getDefaultFsRootID(null)
    });
    if (this.props.storageManager.linkToWoServerSearch) {
      const tooShort = filterText.trim().length < 2 && this.state.filterClient === CLIENTS_OPTION_ALL.value;
      if (tooShort) {
        this.scheduleServerSearch.cancel();
        this.runServerSearch(filterText, this.state.filterClient, 0, false);
      } else {
        this.scheduleServerSearch(filterText, this.state.filterClient, 0);
      }
    }
  };

  handleClientFilter = value => {
    const filterClient = (value || {}).value || CLIENTS_OPTION_ALL.value;
    this.setState({
      currentPage: 0,
      filterClient,
      selectedWorkOrder: null,
      fsRootId: this.getDefaultFsRootID(null)
    });
    if (this.props.storageManager.linkToWoServerSearch) {
      this.scheduleServerSearch.cancel();
      this.runServerSearch(this.state.filterText, filterClient, 0, false);
    }
  };

  handleBackToSelectWoFromConfirm = () => {
    this.setState({
      selectedWorkOrder: null,
      isBeginIngest: true,
      sendCaptionsToQod: true,
      fsRootId: this.getDefaultFsRootID(null)
    });
    const {dispatch} = this.props;
    dispatch && dispatch(setNewWOByFName(null));
    dispatch && dispatch(clearWoStepsData());
  };

  handleBackToInBurbankFromSelectWo = () => {
    const {dispatch} = this.props;
    dispatch && dispatch(showAvailableManualMemfisWOsModal(false, null, {isBackToInBurbankStep: true}));
    this.setState({
      ...this.getDefaultStateForSelectWo(),
      isBeginIngest: true,
      sendCaptionsToQod: true,
      fsRootId: this.getDefaultFsRootID(null)
    });
  };

  handleMarkAsCompleted = (asperaLinkId) => {
    const {dispatch} = this.props;
    dispatch && dispatch(markAsperaLinkAsCompleted(asperaLinkId));
  };

  renderWorkOrders() {
    const {storageManager} = this.props;
    const workOrders = this.props.workOrders || [];
    const {filterText, filterClient, clients, currentPage} = this.state;
    const serverSearch = !!storageManager.linkToWoServerSearch;
    let filteredData = [...workOrders];
    if (!serverSearch) {
      if (filterClient !== 'All') {
        filteredData = filteredData.filter(item => item.clientName === filterClient);
      }
      filteredData = filteredData.filter(item => item.woMemfisId);
      if (filterText && filterText.trim()) {
        filteredData = filteredData.filter(item => {
          for (const key in item) {
            if (item.hasOwnProperty(key) && String(item[key] || '').toLowerCase().includes(filterText.toLowerCase())) {
              return true;
            }
          }
          return false;
        });
      }
    } else {
      filteredData = filteredData.filter(item => item.woMemfisId);
    }
    const pageSize = 100;
    const pageCount = serverSearch
      ? (currentPage + 1 + (storageManager.linkToWoHasMore ? 1 : 0))
      : (Math.ceil(filteredData.length / pageSize) || 1);
    const needPaging = serverSearch ? (currentPage > 0 || !!storageManager.linkToWoHasMore) : pageCount > 1;
    const selectedPage = serverSearch ? currentPage : ((currentPage + 1) > pageCount ? 0 : currentPage);
    const pagedData = serverSearch ? filteredData :
      (needPaging ? filteredData.slice(selectedPage * pageSize, selectedPage * pageSize + pageSize) : filteredData);
    const queryText = (filterText || '').trim();
    const hasClientFilter = filterClient !== 'All';
    let emptyText = 'No work orders';
    if (serverSearch) {
      if (storageManager.availableManualMemfisWOsIsLoading) {
        emptyText = 'Searching...';
      } else if (queryText.length < 2 && !hasClientFilter) {
        emptyText = storageManager.clientByFNameForWO
          ? 'Search by WO#, title, client, format, or episode. Or create a new artwork work order.'
          : 'Search by WO#, title, client, format, or episode.';
      } else {
        emptyText = 'No work orders match';
      }
    } else if (workOrders.length > filteredData.length) {
      emptyText = 'No work orders match';
    }
    return (
      <>
        {storageManager.linkToWoAsperaLink && (
          <LinkInfoContainer>
            <div>Selected folder is associated with Aspera transfer.</div>
            <LinkInfoItem>
              <LinkInfoLabel>Status:</LinkInfoLabel>
              <LinkInfoValue>{this.getAsperaLinkStatusText(storageManager.linkToWoAsperaLink.linkStatus)}</LinkInfoValue>
            </LinkInfoItem>
            <LinkInfoItem>
              <LinkInfoLabel>Started at:</LinkInfoLabel>
              <LinkInfoValue>{formatDate(storageManager.linkToWoAsperaLink.startTime, '', 'MM/DD/YYYY hh:mm:ss A')}</LinkInfoValue>
            </LinkInfoItem>
            <LinkInfoItem>
              <LinkInfoLabel>Progress:</LinkInfoLabel>
              <LinkInfoValue>{storageManager.linkToWoAsperaLink.percentComplete} %</LinkInfoValue>
            </LinkInfoItem>
            <div>
              <div>Link to WO/Ingest (if exists) process will be running after Aspera transfer is completed.</div>
              <div>If you want to mark Aspera transfer as completed manually, please click on the "Mark As Completed" button.</div>
              <div><button className="btn btn-default" onClick={() => this.handleMarkAsCompleted(storageManager.linkToWoAsperaLink.asperaLinkId)}>Mark Aspera transfer As Completed</button></div>
            </div>
            {storageManager.linkToWoAssetIngest && (
              <>
                <div>Selected folder is associated with Asset Ingest process.</div>
                <LinkInfoItem>
                  <LinkInfoLabel>WO Memfis:</LinkInfoLabel>
                  <LinkInfoValue>{storageManager.linkToWoAssetIngest.woMemfis}</LinkInfoValue>
                </LinkInfoItem>
                <LinkInfoItem>
                  <LinkInfoLabel>Status:</LinkInfoLabel>
                  <LinkInfoValue>{storageManager.linkToWoAssetIngest.rootActionID ? `STARTED (LinkToWo action: ${storageManager.linkToWoAssetIngest.rootActionID})` : 'NOT STARTED'}</LinkInfoValue>
                </LinkInfoItem>
              </>
            )}
            {workOrders.length === 0 && storageManager.linkToWoAssetIngest === null && (
              <XXHashWarningDiv>Parent/child folders has active Aspera links - Link to WO process will not be available.</XXHashWarningDiv>
            )}
          </LinkInfoContainer>
        )}

        <Row>
          <Col xs={12} sm={4}>
            <FormGroupSearchStyled>
              <ControlLabel>
                Search:
              </ControlLabel>
              <FormControl
                value={filterText}
                onChange={this.handleSearchFilter}
                placeholder="WO#, title, client, format, episode"
                autoFocus
              />
            </FormGroupSearchStyled>
          </Col>
          <Col xs={12} sm={2} className="hidden-xs"/>
          <Col xs={12} sm={6}>
            <FormGroupSearchStyled>
              <ControlLabel>
                Client:
              </ControlLabel>
              <ClientFilterSelectStyled>
                <Select
                  value={filterClient}
                  options={clients}
                  onChange={this.handleClientFilter}
                  placeholder=""
                />
              </ClientFilterSelectStyled>
            </FormGroupSearchStyled>
          </Col>
        </Row>
        <Table
          data={pagedData}
          emptyText={emptyText}
          onLinkToWO={this.handleSelectWO}
          onLoadClientList={this.handleLoadClientList}
          onSelectClientName={this.handleSelectClientName}
        />
        {
          needPaging ?
            <Paginate
              pageCount={pageCount}
              selectedPage={selectedPage}
              onPageChange={this.handlePageClick}
              nextLabel=">"
              previousLabel="<"
              containerClassName="pagination"
            /> : null
        }
        {serverSearch && storageManager.linkToWoHasMore ?
          <SearchHint>More work orders match. Narrow the search, or go to the next page.</SearchHint> : null
        }
        { storageManager.XxHashIssue
            ? <XXHashWarningDiv>
                <WarningIcon />
                <span>
                  WARNING: XxHash is disabled - {storageManager.XxHashIssue}
                </span>
              </XXHashWarningDiv>
            : null
        }
      </>
    );
  }

  handleSetIsSelectDestination(isSelecting, confirmedDestination) {
    const {dispatch} = this.props;
    this.setState({
      isSelectingDestination: isSelecting,
      confirmedDestination: confirmedDestination || this.state.confirmedDestination,
      // selectedFolder: isBack ? null : this.state.selectedFolder,
    });
    dispatch && dispatch(changeOpenedFoldersInModal({}));
  }

  handleSetSelectDestination(folder) {
    const {finalDestinationData, storageManager: {newWoByFName}} = this.props;
    const woMemfisId = newWoByFName ? newWoByFName : this.state.selectedWorkOrder.woMemfisId
    const str = finalDestinationData.final_destination.split(/[\\/]/).pop();
    let prefix;
    if (!str.startsWith('WO')) {
      prefix = str.slice(0, str.indexOf('WO'));
    }
    this.setState({
      ...this.state,
      selectedFolder: folder,
      resultValue: !folder ? '' : `${folder.key}\\${prefix || ''}${woMemfisId}`,
    })
  }

  handleChangeInput = (event) => {
    const {storageManager: {newWoByFName}} = this.props;
    const woMemfisId = newWoByFName ? newWoByFName : this.state.selectedWorkOrder.woMemfisId
    this.setState({
      ...this.state,
      inputValue: event.target.value,
      resultValue: `${this.state.selectedFolder.key}\\${event.target.value}_${woMemfisId}`,
    });
  }

  renderDestination() {
    const {isBeginIngest, sendCaptionsToQod, fsRootId, fileType, projectType, isDefaultFileType, confirmedDestination, resultValue} = this.state;
    const {availableFsRoots, finalDestinationData, storageManager: {fsRoots}} = this.props;
    const fileTypeOptions = [];
    const projectTypeOptions = {
      default: null
    };

    if (finalDestinationData && finalDestinationData.project_type_exist) {
      const {project_type_file_settings} = finalDestinationData;
      if (project_type_file_settings && Object.keys(project_type_file_settings).length > 0) {
        Object.keys(project_type_file_settings).forEach(key => {
          fileTypeOptions.push({value: key, label: key});
          projectTypeOptions[key] = [];
          project_type_file_settings[key].forEach(item => {
            projectTypeOptions[key].push({value: item.projectType, label: item.projectType});
          })
        });
      }
    }

    const currentFinalDestinationPath = this.getCurrentFinalDestinationPath();
    return (
      <>
        <CustomPathFieldStyled color="black">
          <label>Volume:</label>
          <div className="value no-monospace">
            <FilterSelectStyled className="fs-root-select">
              <Select
                value={fsRootId}
                options={availableFsRoots}
                onChange={v => this.handleSelectFsRoot(v ? v.value : fsRootId)}
                placeholder=""
              />
            </FilterSelectStyled>
          </div>
        </CustomPathFieldStyled>
        {finalDestinationData && finalDestinationData.project_type_exist && (fileType || (fileTypeOptions && fileTypeOptions[0])) &&
        <CustomPathFieldStyled color="black">
          <label>File type:</label>
          <div className="value no-monospace">
            <FilterSelectStyled className="fs-file-type-select">
              <Select
                value={fileTypeOptions.length === 1 ? (fileTypeOptions && fileTypeOptions[0] ? fileTypeOptions[0].value : null) : fileType}
                options={fileTypeOptions}
                onChange={(e) => this.handleSelectFileType(e ? e.value : null)}
                disabled={fileTypeOptions.length === 1}
              />
            </FilterSelectStyled>
          </div>
          <label>Project type:</label>
          <div className="value no-monospace">
            <FilterSelectStyled className="fs-project-type-select">
              <Select
                value={projectType}
                options={fileType === null ? (fileTypeOptions && fileTypeOptions[0] && fileTypeOptions[0].value ? projectTypeOptions[fileTypeOptions[0].value] : null) : projectTypeOptions[fileType]}
                onChange={(e) => this.handleSelectProjectType(e ? e.value : null)}
                placeholder={finalDestinationData && finalDestinationData.default_project_type}
              />
            </FilterSelectStyled>
            <div className="reset">
              <button
                className="btn btn-default reset-btn"
                onClick={() => this.handleSelectProjectType(finalDestinationData && finalDestinationData.default_project_type)}
                disabled={isDefaultFileType}>
                  reset
              </button>
            </div>
          </div>
        </CustomPathFieldStyled>
        }
        <CustomPathFieldStyled color="red">
          <label>Destination:</label>
          <div className={`value${currentFinalDestinationPath ? ' with-btn' : ''}`}>
            <TextEllipsisAdvanced data={preparePathForOsWithoutRoot(confirmedDestination ? resultValue : currentFinalDestinationPath, fsRoots)}/>
            {currentFinalDestinationPath && <Button
                bsStyle="default"
                title="Select Destination"
                onClick={() => this.handleSetIsSelectDestination(true)}
              >
                <i className="far fa-folder-tree"/>
              </Button>}
          </div>
        </CustomPathFieldStyled>
        <CustomPathFieldStyled color="black">
          <label/>
          <div className="value is-begin-ingest">
            <CheckboxStyled className="checkbox">
              <FormControl
                id="checkbox-begin-ingest"
                name="checkbox-begin-ingest"
                type="checkbox"
                checked={isBeginIngest}
                onChange={event => this.setState({isBeginIngest: event.target.checked})}
              />
              <ControlLabel htmlFor="checkbox-begin-ingest">
                Begin file ingest process immediately
              </ControlLabel>
            </CheckboxStyled>
          </div>
        </CustomPathFieldStyled>
        {finalDestinationData && finalDestinationData.show_captions_send_to_qod &&
        <CustomPathFieldStyled color="black">
          <label/>
          <div className="value is-send-captions-to-qod">
            <CheckboxStyled className="checkbox">
              <FormControl
                id="checkbox-send-captions-to-qod"
                name="checkbox-send-captions-to-qod"
                type="checkbox"
                checked={sendCaptionsToQod}
                onChange={event => this.setState({sendCaptionsToQod: event.target.checked})}
              />
              <ControlLabel htmlFor="checkbox-begin-ingest">
                Send captions to QOD
              </ControlLabel>
            </CheckboxStyled>
          </div>
        </CustomPathFieldStyled>
        }
      </>
    );
  }

  handleSetActiveStep = (step_id, checked) => {
    const { dispatch } = this.props;
    dispatch(activateWoStep(step_id, checked));
    if (!checked) {
      this.setState({isAllWoSteps: false});
    }
  }

  handleActivateAll = (checked) => {
    const { dispatch, woSteps } = this.props;
    woSteps.forEach(step => {
      dispatch(activateWoStep(step.step_id, checked));
    });

    this.setState({isAllWoSteps: checked});
  }

  renderSteps() {
    const { woSteps, isWoStepsEmpty } = this.props;

    return (
      <>
        { !woSteps && !isWoStepsEmpty ?
          <p>Loading...</p>
          : null
        }
        { woSteps ?
          <table>
          {
            woSteps.map(step => (
               <tr>
                <td>
                <StyledCheckbox
                  key={`step-${step.step_id}-${step.step_uuid}`}
                  label={step.step_label}
                  title={step.step_description}
                  checked={step.activate}
                  onChange={({target: { checked }}) => this.handleSetActiveStep(step.step_id, checked)}
                  disabled={false}
                >
                  {step.step_label}
                </StyledCheckbox>
                </td>
                <td>
                  <span title={step.step_description}>&nbsp; {step.step_description}</span>
                </td>
               </tr>
              ))
          }
          </table>
          : null
        }

        {
          isWoStepsEmpty ?
            <p className="bg-danger">WO Steps info is not available</p>
            : null
        }
      </>
    );
  }

  renderArtworkWoSetup() {
    const {artworkWoCustomType} = this.state;

    return (
        <ArtworkWorkOrderDiv>
          <span>Select type for new artwork work order:</span>
          <Clearfix>
            <div className="field">
              <div className="radio-wrapper">
                <input
                    name="artwork_wo_type"
                    type="radio"
                    value={ARTWORK_WO_TYPE.GENERAL}
                    checked={!artworkWoCustomType}
                    onChange={this.handleChangeArtworkWoType}
                />
                <label>
                  General
                </label>
              </div>
              <div className="radio-wrapper">
                <input
                    name="artwork_wo_type"
                    type="radio"
                    value={ARTWORK_WO_TYPE.CUSTOM}
                    checked={artworkWoCustomType}
                    onChange={this.handleChangeArtworkWoType}
                />
                <label>
                  Custom
                </label>
              </div>
            </div>
          </Clearfix>
          <FormGroup>
            {artworkWoCustomType ?
              <>
                <span>Enter custom series name (project title):</span>
                <input
                    type="text"
                    className="form-control"
                    ref={r => this.customSeriesInput = r}
                />
                <span>and concept name:</span>
                <input
                    type="text"
                    className="form-control"
                    ref={r => this.conceptNameInput = r}
                />
              </> : <>
                <span>Series name, concept name and year/episode numbers will be obtained from file names</span>
              </>
            }
          </FormGroup>
        </ArtworkWorkOrderDiv>
    );
  }

  renderArtworkValidationResults() {
    const {artworkDuplicateAssetList, selectedAssetsForCancel, artworkValidationResults, expandedZipFiles, checkedZipLkfs, checkedZipProxy} = this.state;

    if (artworkDuplicateAssetList && artworkDuplicateAssetList.length) {
      return (
        <DuplicateAssetsContainer>
          <div className="header">
            <h4>Duplicate Assets Found</h4>
            <p>The following assets already exist. Select assets to cancel (optional):</p>
          </div>
          <DuplicateAssetsTable>
            <thead>
              <tr>
                <th width="50">
                  <Checkbox
                    checked={artworkDuplicateAssetList.length > 0 && artworkDuplicateAssetList.every(asset => !!selectedAssetsForCancel[asset.RequestID])}
                    onChange={this.handleToggleAllArtworkAssetsForCancel}
                  />
                </th>
                <th width="150">Asset Name</th>
                <th width="180">Submitted On</th>
                <th width="100">QC Status</th>
                <th width="100">WO Memfis</th>
              </tr>
            </thead>
            <tbody>
              {artworkDuplicateAssetList.map((asset) => (
                <tr key={asset.RequestID}>
                  <td>
                    <Checkbox
                      checked={!!selectedAssetsForCancel[asset.RequestID]}
                      onChange={() => this.handleToggleArtworkAssetForCancel(asset.RequestID)}
                    />
                  </td>
                  <td title={asset.FilePath}>{asset.AssetName}</td>
                  <td>{asset.CreatedOn ? moment.unix(asset.CreatedOn).format('MM/DD/YYYY hh:mm:ss A') : '-'}</td>
                  <td>{asset.QcStatus || '-'}</td>
                  <td>{asset.WOMemfis || '-'}</td>
                </tr>
              ))}
            </tbody>
          </DuplicateAssetsTable>
        </DuplicateAssetsContainer>
      );
    }

    if (!artworkValidationResults) {
      return <p>No validation results available.</p>;
    }

    const {results, total_files, invalid_files_count, zip_files} = artworkValidationResults;

    return (
      <ArtworkValidationResultsDiv>
        <div className="summary">
          <span>Total files: <strong>{total_files}</strong></span>
          <span className="unmatched">Invalid: <strong>{invalid_files_count}</strong></span>
          <Button bsStyle="default" bsSize="small" onClick={this.handleValidateArtworkFolder}>
            Re-validate
          </Button>
        </div>
        {results && results.length > 0 && (
          <ValidationResultsTable>
            <thead>
              <tr>
                <th>File Name</th>
                <th width="150">Spec</th>
                <th width="120">Reference Proxy</th>
                <th>Issues</th>
              </tr>
            </thead>
            <tbody>
              {results.map((file, idx) => {
                const hasErrors = file.validation_errors && file.validation_errors.length > 0;
                const hasWarnings = file.validation_warnings && file.validation_warnings.length > 0;
                const hasSpec = !!file.spec_name;
                const refProxy = file.reference_proxy;
                return (
                  <tr key={idx} className={hasErrors && !hasSpec ? 'row-error' : ''}>
                    <td title={file.file_name}>{file.file_name}</td>
                    <td>{hasSpec ? file.spec_name : <span className="text-danger">No match</span>}</td>
                    <td>
                      {refProxy && refProxy.found
                        ? <span className="text-success">
                            {refProxy.source === 'current_file_list' ? 'In file list' : 'In project'}
                            {refProxy.reference_file_name ? `: ${refProxy.reference_file_name}` : ''}
                          </span>
                        : <span className="text-danger">Not found</span>
                      }
                    </td>
                    <td>
                      {hasErrors &&
                        <ul className="error-list">
                          {file.validation_errors.map((err, i) => <li key={i}>{err}</li>)}
                        </ul>
                      }
                      {hasWarnings &&
                        <ul className="warning-list">
                          {file.validation_warnings.map((warn, i) => <li key={i}>{warn}</li>)}
                        </ul>
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </ValidationResultsTable>
        )}
        {zip_files && zip_files.length > 0 && (
          <ZipFilesSection>
            <h5>Zip Files</h5>
            {zip_files.map((zipFile, idx) => {
              const isExpanded = !!expandedZipFiles[zipFile.file_name];
              const hasErrors = zipFile.validation_errors && zipFile.validation_errors.length > 0;
              return (
                <ZipFileItem key={idx}>
                  <div className="zip-header" onClick={() => this.handleToggleZipFileExpanded(zipFile.file_name)}>
                    <span className="toggle-icon">{isExpanded ? '\u25BC' : '\u25B6'}</span>
                    <span className="zip-name">{zipFile.file_name}</span>
                    {hasErrors && (
                      <ul className="zip-errors">
                        {zipFile.validation_errors.map((err, i) => <li key={i}>{err}</li>)}
                      </ul>
                    )}
                  </div>
                  {isExpanded && zipFile.zip_content && (
                    <ul className="zip-content-list">
                      {zipFile.zip_content.map((contentItem, cIdx) => {
                        const contentKey = `${zipFile.content_id}::${contentItem.file}`;
                        return (
                          <li key={cIdx} className="zip-content-row">
                            <Checkbox
                              inline
                              checked={!!checkedZipLkfs[contentKey]}
                              onChange={() => this.handleToggleZipLkfsItem(zipFile.content_id, contentItem.file)}
                            >
                              LKFS
                            </Checkbox>
                            <Radio
                              inline
                              name={`proxyAudio_${zipFile.content_id}`}
                              checked={!!checkedZipProxy[contentKey]}
                              onChange={() => this.handleSelectZipProxyItem(zipFile.content_id, contentItem.file)}
                            >
                              Proxy
                            </Radio>
                            <span className="content-file-name">{contentItem.file}</span>
                            {contentItem.is_audiostem_lkfs && <span className="badge badge-lkfs">LKFS</span>}
                            {contentItem.is_audiostem_proxy && <span className="badge badge-proxy">Proxy</span>}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </ZipFileItem>
              );
            })}
          </ZipFilesSection>
        )}
      </ArtworkValidationResultsDiv>
    );
  }

  renderContent(step) {
    const {item, storageManager: {newWoByFName, availableManualMemfisWOsIsLoading}} = this.props;
    const {selectedWorkOrder} = this.state;
    return (
      <>
        <CustomPathFieldStyled>
          <label className={step === Steps.SELECT_WO ? 'min-w-80' : undefined}>Linking:</label>
          <TextEllipsisAdvanced className="value" data={getValueForOS(item, 'key')}/>
        </CustomPathFieldStyled>
        {
          step === Steps.CONFIRM ?
            <CustomPathFieldStyled color="black">
              <label>To:</label>
              <div className="value no-monospace">{newWoByFName ? newWoByFName : buildWOInfo(selectedWorkOrder)}</div>
            </CustomPathFieldStyled> : null
        }
        {step === Steps.SELECT_WO ? this.renderWorkOrders() : null}
        {step === Steps.CONFIRM ? this.renderDestination() : null}
        {step === Steps.WO_STEPS ? this.renderSteps() : null}
        {step === Steps.ARTWORK_WO_SETUP ? this.renderArtworkWoSetup() : null}
        {step === Steps.ARTWORK_WO_SETUP && this.state.artworkValidationLoading ?
          <WoCreationLoaderStyled>
            <Spinner/>
            <span>Validating ingest package...</span>
          </WoCreationLoaderStyled> : null
        }
        {step === Steps.ARTWORK_WO && !this.state.artworkValidationLoading ? this.renderArtworkValidationResults() : null}
        {step === Steps.ARTWORK_WO && this.state.artworkValidationLoading ?
          <WoCreationLoaderStyled>
            <Spinner/>
            <span>Validating ingest package...</span>
          </WoCreationLoaderStyled> : null
        }
        {step === Steps.ARTWORK_WO && availableManualMemfisWOsIsLoading && !this.state.artworkValidationLoading ?
          <WoCreationLoaderStyled>
            <Spinner/>
            <span>Please wait while a new Work Order is being created...</span>
          </WoCreationLoaderStyled> : null
        }
      </>
    );
  }

  handleWoSteps = () => {
    this.wizard.setActiveStepKey(Steps.CONFIRM);
  }

  buildSteps = () => {
    const {
      item, startsWithLinkInBurbank, onCompleteDownloadForMultipleWOs, dispatch, storageManager: {isLoadingModal, clientByFNameForWO, newWoByFName},
      isLoading, saving, finalDestinationIsLoading, clientNameIsLoading
    } = this.props;
    const {inBurbankStepData, selectedWorkOrder, isSelectingDestination, selectedFolder, artworkWoid} = this.state;

    const currentFinalDestinationPath = this.getCurrentFinalDestinationPath();
    const woWithoutClient = this.isWorkOrderWithoutClient(selectedWorkOrder);
    return {
      ...(startsWithLinkInBurbank ? {
        [Steps.IN_BURBANK]: {
          stepName: Steps.IN_BURBANK,
          onContinue: () => {
            const {singleLinking, searchWOsForContent, continueVariant} = inBurbankStepData;
            if (continueVariant === CONTINUE_COMPLETE_DOWNLOAD) {
              onCompleteDownloadForMultipleWOs(item);
              return Steps.IN_BURBANK;
            } else {
              const {fsRootID, contentID} = item;
              const ajaxParams = searchWOsForContent ? {fs_root_id: fsRootID, content_id: contentID} :
                (singleLinking || continueVariant === CONTINUE_SINGLE_LINK_WO) ? {single_linking: true} : undefined;
              dispatch && dispatch(showAvailableManualMemfisWOsModal(true, ajaxParams));
            }
          }
        }
      } : {}),
      [Steps.SELECT_WO]: {
        stepName: clientByFNameForWO ? 'Select or create a new WO#' : Steps.SELECT_WO,
        allowBack: () => startsWithLinkInBurbank,
        onBack: () => this.handleBackToInBurbankFromSelectWo(),
        allowContinue: () => false,
        newBtnTitle: "New Artwork WO",
        allowNewBtn: clientByFNameForWO
      },
      [Steps.CONFIRM]: {
        stepName: isSelectingDestination ? 'Select Destination' : Steps.CONFIRM,
        ...(isSelectingDestination ? {
          onBack: () => {
            //this.handleSetIsSelectDestination(false, false);
            return Steps.WO_STEPS;
          },
          getTitleContinue: () => 'Confirm selected destination',
          getLabelContinue: () => 'Continue',
          allowContinue: () => {
            return !(
              !selectedFolder || isLoading || isLoadingModal
            );
          },
          onContinue: () => {
            this.handleSetIsSelectDestination(false, true);
            return Steps.CONFIRM;
          }
        } : {
          allowBack: () => {
            return !(
              saving || isLoading
            );
          },
          onBack: () => {
            //this.handleBackToSelectWoFromConfirm()
            return Steps.WO_STEPS;
          },
          getTitleContinue: () => woWithoutClient ? 'Link to WO without client info!' : undefined,
          getInfoContinue: () => woWithoutClient ? <Info className="fas fa-exclamation-circle"/> : null,
          allowContinue: () => {
            return !(
              (!selectedWorkOrder && !newWoByFName) || saving || isLoading || finalDestinationIsLoading || !currentFinalDestinationPath ||
              clientNameIsLoading
            );
          },
          onContinue: () => this.handleLinkToWO()
        })
      },
      [Steps.WO_STEPS]: {
        stepName: Steps.WO_STEPS,
        allowBack: () => {
          return true;
        },
        onBack: () => {
          if (isSelectingDestination) {
            this.handleSetIsSelectDestination(false, false);
          } else {
            this.handleBackToSelectWoFromConfirm();
          }
          this.setState({isAllWoSteps: false});
          dispatch(clearWoStepsData());
          return Steps.SELECT_WO;
        },
        getLabelContinue: () => 'Continue',
        allowContinue: () => {
          return true;
        },
        onContinue: () => {return Steps.CONFIRM;}
      },
      [Steps.ARTWORK_WO_SETUP]: {
        stepName: 'Artwork WO Setup',
        allowBack: () => {
          return true;
        },
        onBack: () => {
          return Steps.SELECT_WO;
        },
        getTitleContinue: () => 'Validate artwork files',
        getLabelContinue: () => 'Validate',
        allowContinue: () => {
          return !this.state.artworkValidationLoading;
        },
        onContinue: () => {
          this.handleValidateArtworkFolder();
        }
      },
      [Steps.ARTWORK_WO]: {
        stepName: Steps.ARTWORK_WO,
        allowBack: () => {
          return !artworkWoid;
        },
        onBack: () => {
          return Steps.ARTWORK_WO_SETUP;
        },
        getTitleContinue: () => artworkWoid ? 'Continue' : 'Create new artwork work order',
        getLabelContinue: () => artworkWoid ? 'Continue' : 'Create artwork work order',
        allowContinue: () => {
          return true;
        },
        onContinue: this.handleCreateArtworkWorkOrder
      }
    };
  };

  render() {
    const {isLoading, clientNameIsLoading, dispatch, storageManager, onCompleteDownloadForMultipleWOs,
      finalDestinationIsLoading, saving
    } = this.props;
    const {isSelectingDestination, selectedFolder, confirmedDestination, inputValue, resultValue, inBurbankStepData
    } = this.state;
    const {foldersInModal, openedFoldersInModal, currentView, loaders, isLoadingModal, fsRoots, availableManualMemfisWOsIsLoading} = storageManager;
    return (
      <Wizard
        onRef={ref => {
          this.wizard = ref;
        }}
        wizardName="Link to WO"
        bsSize={(step) => step === Steps.SELECT_WO || step === Steps.ARTWORK_WO ? 'large' : undefined}
        className="link-to-memfis-wo-modal"
        onCancel={this.handleClose}
        onNew={this.handleNewArtworkWorkOrder}
        isLoading={isLoading || clientNameIsLoading || (!!onCompleteDownloadForMultipleWOs && (finalDestinationIsLoading || saving || isLoadingModal || availableManualMemfisWOsIsLoading))}
        steps={this.buildSteps()}
        getChildren={step => (
          step === Steps.IN_BURBANK ?
            <InBurbankStep
              isRequiredContinueVariant={!!onCompleteDownloadForMultipleWOs}
              data={inBurbankStepData}
              onChange={newValues => {
                this.setState({inBurbankStepData: {...inBurbankStepData, ...newValues}});
              }}
            /> :
          <>
            {isSelectingDestination && selectedFolder && <>
              <CustomPathFieldStyled color="red" labelWidth="145">
                <label>Default destination:</label>
                <TextEllipsisAdvanced className="value" data={preparePathForOsWithoutRoot(this.getCurrentFinalDestinationPath(), fsRoots)}/>
              </CustomPathFieldStyled>
              <CustomPathFieldStyled color="red" labelWidth="145">
                <label>Parent Folder:</label>
                <TextEllipsisAdvanced className="value" data={getValueForOS(selectedFolder, 'key')}/>
              </CustomPathFieldStyled>
              <FormGroupStyled>
                <ControlLabel>Prefix:</ControlLabel>
                <FormControl
                  value={inputValue}
                  onChange={this.handleChangeInput}
                  onBlur={this.handleChangeInput}
                  inputRef={ref => {
                    this._input = ref;
                  }}
                />
              </FormGroupStyled>
              <CustomPathFieldStyled color="red" labelWidth="145">
                <label>Result:</label>
                <TextEllipsisAdvanced className="value" data={preparePathForOsWithoutRoot(resultValue, fsRoots)}/>
              </CustomPathFieldStyled>
              <hr/>
            </>}
            {isSelectingDestination && dispatch ?
              <FolderExplorerNew
                dispatch={dispatch}
                loaders={loaders}
                folders={foldersInModal}
                openedFolders={openedFoldersInModal}
                currentView={currentView}
                folderToExpand={confirmedDestination ? selectedFolder : {key: this.getCurrentFinalDestinationPath(), fsRootID: this.getCurrentFinalDestinationRootId()}}
                selectedFolder={selectedFolder}
                onSelectFolder={(folder) => this.handleSetSelectDestination(folder)}
                linkToWo={true}
                selectedFolderLabelWidth={145}
                storageManager={storageManager}
              /> :
              this.renderContent(step)}
          </>
        )}
      />
    );
  }
}

const CustomPathFieldStyled = styled(PathFieldStyled)`
  align-items: center;

  .fs-root-select,
  .fs-file-type-select {
    width: 65px;
  }

  label {
    min-width: ${props => `${props.labelWidth || 115}px`};
    + div {
      max-width: calc(100% - ${props => `${props.labelWidth || 115}px`});
      &.value {
        &:not(.text--ellipsis--advanced) {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-grow: 1;
          > .text--ellipsis--advanced {
            max-width: 100%;
          }
          &.with-btn {
            > .text--ellipsis--advanced {
              max-width: calc(100% - 55px);
            }
          }
        }
      }
    }

    &.min-w-80 {
      min-width: 80px;
      + div {
        max-width: calc(100% - 80px);
      }
    }
  }

  .fs-project-type-select {
    margin-right: 5px;
  }

  button.reset-btn {
    height: 27px;
    padding: 1px 10px;
  }
`;

const FormGroupStyled = styled(FormGroup)`
  margin-bottom: 6px;
  .control-label {
    font-size: 10px;
    margin-left: 0;
    padding: 0;
  }
`;

const Info = styled.i`
  margin-left: 3px;
  color: red;
  font-size: 15px;
  background-color: white;
  border-radius: 50%;
  box-shadow: none;
  text-shadow: none;
`;

const ClientFilterSelectStyled = styled(FilterSelectStyled)`
  width: 100%;

  .Select.has-value.Select--single,
  .Select.Select--single,
  .Select.is-searchable.Select--single,
  .Select--multi {

    > .Select-control {
      height: 34px;
      .Select-multi-value-wrapper {
        height: 32px;
        .Select-placeholder,
        .Select-value {
          font-size: 13px !important;
          line-height: 14px !important;
          .Select-value-label {
            font-size: 13px !important;
            line-height: 14px !important;
            opacity: 0.65;
          }
        }
        .Select-input {
          padding-left: 9px;
          height: 32px;
          input {
            font-size: 13px !important;
          }
        }
      }
    }

    &.is-open {
      > .Select-control {
        .Select-multi-value-wrapper {
          .Select-placeholder,
          .Select-value {
            .Select-value-label {
              opacity: 1;
            }
          }
        }
      }
    }
  }
`;

const SearchHint = styled.div`
  margin-top: 8px;
  color: #666;
  font-size: 12px;
`;

const FormGroupSearchStyled = styled(FormGroup)`
  display: flex;
  align-items: center;

  label {
    margin: 0;
    padding: 0;
    font-weight: bold;
    min-width: 80px;
  }

  .form-control {
    width: 100%;
    font-size: 13px;

    &:not(:focus) {
      opacity: 0.65;
    }
  }
`;

const StyledCheckbox = styled(Checkbox)`
  margin: 0;
`;

const ArtworkWorkOrderDiv = styled.div`
  .radio-wrapper {
    display: flex;

    input {
      margin: 0;
    }

    label {
      margin: 0 0 0 5px;
    }
  }

  .form-group span {
    display: block;
    margin-top: 7px;
  }
`;

const XXHashWarningDiv = styled.div`
  margin-top: 5px;
  background-color: #ffbf03;
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;

  span {
    margin-left: 5px;

    svg {
      color: white;
      vertical-align: middle;
    }
  }
`;

const LinkInfoContainer = styled.div`
  margin-bottom: 10px;
  padding: 8px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
`;

const LinkInfoItem = styled.div`
  display: flex;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }
`;

const LinkInfoLabel = styled.span`
  font-weight: bold;
  min-width: 120px;
  margin-right: 10px;
  color: #495057;
`;

const LinkInfoValue = styled.span`
  color: #212529;
  word-break: break-all;
  flex: 1;
`

const DuplicateAssetsContainer = styled.div`
  .header {
    margin-bottom: 15px;

    h4 {
      margin: 0 0 10px 0;
      color: #333;
    }

    p {
      margin: 0;
      color: #666;
      font-size: 14px;
    }
  }

  .actions {
    margin-top: 15px;
    text-align: right;
  }
`;

const DuplicateAssetsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  thead {
    background-color: #f5f5f5;

    th {
      padding: 8px;
      text-align: left;
      border: 1px solid #ddd;
      font-weight: bold;
      white-space: nowrap;
    }
  }

  tbody {
    tr {
      &:hover {
        background-color: #f9f9f9;
      }

      td {
        padding: 5px;
        border: 1px solid #ddd;
        vertical-align: middle;
        overflow: hidden;
        word-wrap: break-word;
        max-width: 0;
      }
    }
  }
`;

const WoCreationLoaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  padding: 15px;

  .react-spinner {
    position: relative;
    width: 24px;
    height: 24px;
    display: inline-block;
  }

  .react-spinner_bar {
    animation: react-spinner_spin 1.2s linear infinite;
    border-radius: 5px;
    background-color: #29d;
    position: absolute;
    width: 20%;
    height: 7.8%;
    top: 39.9%;
    left: 40%;
  }

  span {
    margin-left: 12px;
    font-size: 14px;
    color: #555;
  }
`;

const ArtworkValidationResultsDiv = styled.div`
  .summary {
    margin-bottom: 10px;
    padding: 8px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    display: flex;
    gap: 20px;
    align-items: center;

    .unmatched {
      color: #dc3545;
    }
  }
`;

const ValidationResultsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  thead {
    background-color: #f5f5f5;

    th {
      padding: 8px;
      text-align: left;
      border: 1px solid #ddd;
      font-weight: bold;
      white-space: nowrap;
    }
  }

  tbody {
    tr {
      &:hover {
        background-color: #f9f9f9;
      }

      &.row-error {
        background-color: #fff3f3;
      }

      td {
        padding: 5px 8px;
        border: 1px solid #ddd;
        vertical-align: top;
        word-break: break-all;

        .error-list {
          margin: 0;
          padding-left: 16px;
          color: #dc3545;
          font-size: 12px;

          li {
            margin-bottom: 2px;
          }
        }

        .warning-list {
          margin: 0;
          padding-left: 16px;
          color: #e67e22;
          font-size: 12px;

          li {
            margin-bottom: 2px;
          }
        }

        .text-danger {
          color: #dc3545;
        }

        .text-success {
          color: #28a745;
        }

        .text-muted {
          color: #999;
        }
      }
    }
  }
`;

const ZipFilesSection = styled.div`
  margin-top: 15px;

  h5 {
    margin: 0 0 10px 0;
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
`;

const ZipFileItem = styled.div`
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 8px;

  .zip-header {
    display: flex;
    align-items: flex-start;
    padding: 8px 10px;
    background-color: #f5f5f5;
    cursor: pointer;
    user-select: none;

    &:hover {
      background-color: #eee;
    }

    .toggle-icon {
      margin-right: 8px;
      font-size: 11px;
      color: #555;
      flex-shrink: 0;
      margin-top: 2px;
    }

    .zip-name {
      font-weight: 600;
      font-size: 13px;
      word-break: break-all;
    }

    .zip-errors {
      margin: 0 0 0 15px;
      padding-left: 16px;
      color: #dc3545;
      font-size: 12px;
      list-style: disc;

      li {
        margin-bottom: 2px;
      }
    }
  }

  .zip-content-list {
    list-style: none;
    margin: 0;
    padding: 0;
    border-top: 1px solid #ddd;

    li {
      padding: 4px 10px 4px 28px;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      gap: 8px;

      &:last-child {
        border-bottom: none;
      }

      .checkbox, .radio {
        margin: 0;
        display: inline-flex;
        align-items: center;
        flex-shrink: 0;
      }

      .content-file-name {
        font-size: 12px;
        word-break: break-all;
        flex: 1;
        min-width: 0;
      }

      .badge {
        display: inline-block;
        padding: 1px 5px;
        font-size: 10px;
        border-radius: 3px;
        font-weight: bold;
        color: #fff;
        flex-shrink: 0;
      }

      .badge-lkfs {
        background-color: #17a2b8;
      }

      .badge-proxy {
        background-color: #6f42c1;
      }
    }
  }
`;

LinkToMemfisWoModal.propTypes = {
  dispatch: PropTypes.func,
  storageManager: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  item: PropTypes.object.isRequired,
  workOrders: PropTypes.array/*.isRequired*/,
  saving: PropTypes.bool.isRequired,
  availableFsRoots: PropTypes.array.isRequired,
  finalDestinationIsLoading: PropTypes.bool.isRequired,
  finalDestinationData: PropTypes.object,
  clientNameIsLoading: PropTypes.bool,
  startsWithLinkInBurbank: PropTypes.bool.isRequired,
  onCompleteDownloadForMultipleWOs: PropTypes.func,
  linkToMemfisWOCallback: PropTypes.func,
  requestedPage: PropTypes.string,
  woSteps: PropTypes.object.isRequired,
  isWoStepsEmpty: PropTypes.bool.isRequired
};

export default LinkToMemfisWoModal;
